import { Canvas, TEvent } from 'fabric';
import { FabricCanvasTool } from '../index';
import { SketchProperties, Tool } from '../../../../types';

// eslint-disable-next-line import/prefer-default-export
export class ZoomCursor extends FabricCanvasTool {
    private readonly mode: Tool.ZOOM_IN | Tool.ZOOM_OUT;

    private readonly zoomFactor: number;

    private readonly minZoom = 0.1;

    private readonly maxZoom = 10;

    private onChange: ((evt?: any) => void) | undefined;

    private sketchWidth: number = 0;

    private sketchHeight: number = 0;

    type(): Tool {
        return this.mode;
    }

    constructor(canvas: Canvas, mode: Tool.ZOOM_IN | Tool.ZOOM_OUT) {
        super(canvas);
        this.mode = mode;
        this.zoomFactor = mode === Tool.ZOOM_IN ? 1.25 : 0.8;
    }

    configureCanvas(props: SketchProperties) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        this.canvas.forEachObject(o => { o.selectable = false; o.evented = false; });
        this.canvas.defaultCursor = this.mode === Tool.ZOOM_IN ? 'zoom-in' : 'zoom-out';
        this.onChange = props.onChange;
        this.sketchHeight = props.height || 0;
        this.sketchWidth = props.width || 0;
    }

    doMouseDown(o: TEvent) {
        const currentZoom = this.canvas.getZoom();
        const newZoom = currentZoom * this.zoomFactor;
        if (newZoom >= this.minZoom && newZoom <= this.maxZoom) {
            // handle zoom the same way as we do in the desktop tool, to prevent the canvas contents clipping out
            const newWidth = this.sketchWidth * newZoom;
            const newHeight = this.sketchHeight * newZoom;
            this.canvas.setZoom(newZoom);
            this.canvas.setDimensions({ width: newWidth, height: newHeight });
            // move canvas container if needed to keep the zoom point in the same position
            const pointer = this.canvas.getViewportPoint(o.e);
            const canvasContainer = this.canvas.wrapperEl.parentElement!;
            let scrollX = 0;
            let scrollY = 0;
            if (newWidth > canvasContainer.clientWidth) {
                scrollX = pointer.x * (this.zoomFactor - 1);
            }
            if (newHeight > canvasContainer.clientHeight) {
                scrollY = pointer.y * (this.zoomFactor - 1);
            }
            canvasContainer.scrollBy(scrollX, scrollY);
            if (this.onChange) {
                this.onChange();
            }
        }
    }
}
